export namespace ThemeTypes {
  export enum ThemeVariant {
    Light = 'Light',
    Dark = 'Dark',
  }
}
